"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'reports.access.denied.title': 'Access Denied',
    'reports.access.denied.enterprise': 'Enterprise users do not have access to cost reports.',
    'reports.access.denied.general': 'Only parent users and super administrators can access cost reports.',
};
